import './Domain.sass';

import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router5';

import { BottomBar, Button, Form, FormItem, Header, Input, ScrollView } from '$uikit';
import { RESOLVE } from '$shared/constants/pages';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { profileActions } from '$store/profile';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';
import { PUBLIC_URL } from '$shared/constants';

export const Domain: FC = () => {
  const { isLogged } = useSelector(authSelector);
  const user = useCurrentUserInfo();
  const dispatch = useDispatch();
  const t = useTranslator();
  const [domain, setDomain] = useState(user.domain || '');
  const [error, setError] = useState('');
  const hostRef = useRef<HTMLDivElement>(null);
  const [hostWidth, setHostWidth] = useState(0);

  useEffect(() => {
    hostRef.current && setHostWidth(hostRef.current.clientWidth);
  }, [hostRef.current, setHostWidth]);

  const handleChange = useCallback(({ target }) => {
    setDomain(target.value.trim());
  }, []);

  useEffect(() => {
    let timer: any = 0;
    if (domain) {
      if (domain === user.domain) {
        setError('');
        return;
      }
      timer = setTimeout(() => {
        dispatch(
          profileActions.checkDomain({
            domain,
            onDone: () => setError('ok'),
            onFail: (msg) => setError(msg),
          }),
        );
      }, 1000);
    } else {
      setError(user.domain ? 'ok' : '');
    }
    return () => clearTimeout(timer);
  }, [domain]);

  const handleSave = useCallback(() => {
    dispatch(profileActions.changeDomain(domain));
  }, [dispatch, domain]);

  function renderError() {
    if (error === 'ok') {
      if (domain.length === 0) {
        return null;
      }
      return t('domain_available');
    } else if (error) {
      return <div className="Domain__error">{error}</div>;
    } else {
      return null;
    }
  }

  if (!isLogged) {
    return <AuthRequired />;
  }

  return (
    <>
      <Header showCloseButton>{t('domain_title')}</Header>
      <ScrollView>
        <div className="Domain__message">
          {t('domain_caption')}
          {` `}
          <Link routeName={RESOLVE} routeParams={{ domain: 'andrew' }}>
            {PUBLIC_URL}/andrew
          </Link>
          .
        </div>
        <div>
          <ul>
            <li>{t('domain_req1')};</li>
            <li>{t('domain_req2')};</li>
            <li>{t('domain_req3')};</li>
            <li>{t('domain_req4')};</li>
          </ul>
        </div>
        <Form>
          <FormItem title="Адрес" description={renderError()}>
            <div className="Domain__input">
              <div ref={hostRef} className="Domain__host">
                {PUBLIC_URL.replace('https://', '')}/
              </div>
              <Input
                style={{ paddingLeft: hostWidth + 16 + 1 }}
                placeholder={t('domain_enter_username')}
                value={domain}
                onChange={handleChange}
                maxLength={15}
              />
            </div>
          </FormItem>
        </Form>
      </ScrollView>
      <BottomBar fixed direction="column">
        <Button onClick={handleSave} disabled={error !== 'ok'}>
          {t('save')}
        </Button>
      </BottomBar>
    </>
  );
};
